import { WorkspacesLayout } from '@/components/ui-new/containers/WorkspacesLayout';

export function Workspaces() {
  return <WorkspacesLayout />;
}
